import _objectSpread from "/home/jenkins/agent/workspace/front_prod/ai-ppt/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import axios from 'axios';
import util from '@webfront-components-vue/sign-utils';
import CPopUp from '../components/common/CPopUp/index';
import { useWhite } from '../state/whiteList';
import { useSecretStore, useUserStore } from '../store';
axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000; // 请求超时时间60秒

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params, option = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, _objectSpread({
      params
    }, option)).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, signal, timeout, responseType) {
  const {
    urlParams
  } = params;
  let urlParamStr = '';
  if (urlParams) {
    // eslint-disable-next-line guard-for-in
    for (const k in params.urlParams) {
      urlParamStr = urlParamStr ? urlParamStr + `&${k}=${urlParams[k]}` : `?${k}=${urlParams[k]}`;
    }
  }
  const requestUrl = urlParamStr ? `${url}${urlParamStr}` : url;
  return new Promise(resolve => {
    if (timeout) {
      axios.post(requestUrl, params, {
        signal,
        timeout,
        responseType
      }).then(res => {
        resolve(res.data);
      }).catch(err => {
        resolve(err);
      });
    } else {
      axios.post(requestUrl, params, {
        signal,
        responseType
      }).then(res => {
        resolve(res.data);
      }).catch(err => {
        resolve(err);
      });
    }
  });
}
export function put(url, params) {
  return new Promise(resolve => {
    axios.put(url, params).then(res => {
      resolve(res.data);
    }).catch(err => {
      resolve(err);
    });
  });
}
export function deleteParams(url, params) {
  return new Promise(resolve => {
    axios.delete(url, {
      params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      resolve(err);
    });
  });
}
export function postFormData(url, data, timeout) {
  const params = data;
  const fd = new FormData();
  Object.keys(params).forEach(key => {
    fd.append(key, params[key]);
  });
  return new Promise((resolve, reject) => {
    const moreParams = {};
    if (timeout) moreParams.timeout = timeout;
    axios.post(url, fd, moreParams).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    });
  });
}

/**
 * post接口，带options选项
 * @param {*} url [请求的url地址]
 * @param {*} data [请求时携带的参数]
 * @param {*} options [请求时额外携带参数，比如headers]
 * @returns
 */
export function postWithOptions(url, data, options) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, options).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    });
  });
}
/**
 * 获取v3请求前的数据
 * @param {*} config
 */
function getSyncUploadRequestData(config = {}) {
  const {
    method,
    data = {},
    params = {}
  } = config;
  switch (method.toLowerCase()) {
    case 'post':
    case 'delete':
    case 'put':
      return delete data.urlParams;
    case 'get':
      return params;
    default:
      return data;
  }
}
/**
 * 设置v3签名后的数据
 * @param {*} config
 * @param {*} data
 */
function setSyncUploadRequestData(config = {}, data = {}, needToken = false) {
  const {
    method
  } = config;
  const obj = config;
  const setData = data;
  if (needToken) {
    const useStore = useSecretStore();
    setData.token = useStore.token;
  }
  switch (method.toLowerCase()) {
    case 'post':
    case 'delete':
    case 'get':
      obj.params = setData;
      break;
    default:
      obj.data = setData;
      break;
  }
}
const {
  VUE_APP_KEYID: keyId,
  VUE_APP_SECRET: secret,
  VUE_APP_VIP_KEYID: vipKeyId,
  VUE_APP_VIP_SECRET: vipSecret
} = process.env;
axios.interceptors.request.use(axiosConfig => {
  let signData;
  const useStore = useSecretStore();
  const useUser = useUserStore();
  if (useWhite.vipWhiteList.some(e => axiosConfig.url.indexOf(e) !== -1)) {
    const requestData = getSyncUploadRequestData(axiosConfig);
    signData = util.genParamV3(requestData, vipSecret, vipKeyId, 'ai-ppt-web', 'aippt.web', '', '', '', '', '', '', '', '', useStore.yduuid);
  } else if (useWhite.skipWhiteList.some(e => axiosConfig.url.indexOf(e) === -1)) {
    const requestData = getSyncUploadRequestData(axiosConfig);
    signData = util.genParamV3(requestData, secret, keyId, 'ai-ppt-web', 'aippt.web', '', '', '', '', '', '', '', '', useStore.yduuid);
  }
  setSyncUploadRequestData(axiosConfig, signData, true);
  return axiosConfig;
}, error => {
  Promise.reject(error);
});
const {
  VUE_APP_LOGIN_URL: loginUrl
} = process.env;
axios.interceptors.response.use(response => {
  var _response$data;
  const {
    headers
  } = response;
  const exceed = Object.keys(headers).find(key => key.toLowerCase() === 'exceedmaxdevicecnt');
  if (headers && headers[exceed] === 'true') {
    const useStore = useUserStore();
    // 因设备退出未登录
    CPopUp({
      confirmButtonText: '重新登录',
      // 确认按钮文案
      text: '您同时登录的设备数过多，已被挤下线，登录新账号，可继续使用~',
      // 提示信息
      confirm: () => {
        useStore.changeShowLoginPanel(true);
      },
      cancel: () => {
        const localUrl = encodeURIComponent(window.location.href);
        window.location.href = `https://dict.youdao.com/login/acc/se/reset?product=DICT&samesite=true&ru=${localUrl}`;
      }
    });
  }
  // 未登录
  if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === 401) {
    showToast({
      message: '已退出登录',
      className: 'c-toast'
    });
    const localUrl = window.location.href;
    const redirectUrl = `${localUrl.split('#')[0]}#/home`;
    window.location.href = redirectUrl;
  }
  return response;
}, err => {
  if (err.code === 'ERR_NETWORK') {
    showToast({
      message: '网络连接失败，请稍后再试~',
      className: 'c-toast'
    });
  }
  return Promise.reject(err);
});